import { render, staticRenderFns } from "./HospitalQuestionList.vue?vue&type=template&id=349bcca4&"
import script from "./HospitalQuestionList.vue?vue&type=script&lang=js&"
export * from "./HospitalQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./HospitalQuestionList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports